<template>
  <div class="contents">
    <h1>Account</h1>

    <div class="contents__detail-box">
      <div class="contents__detail-table contents__account-detail-table">
        <div class="row">
          <span class="field">ADDRESS</span>
          <span class="value">
            {{ account.address }}
            <button
              class="btn-copy"
              :class="{ 'btn-copy--press': copyButtonPressed }"
              v-clipboard:copy="account.address"
              @click="pressCopyButton"
            >
              <div v-if="!copyButtonPressed" class="copy">
                <img src="../../assets/img/copy-icon.svg" />COPY
              </div>
              <div v-else class="copied">COPIED</div>
            </button>
          </span>
        </div>

        <div class="row">
          <span class="field">AMOUNT</span>
          <span class="value"> {{ account.amount }}</span>
        </div>

<!--        <div class="row" v-if="account.issuer">-->
<!--          <span class="field">ISSUER</span>-->
<!--          <span class="value"> {{ account.issuer }}</span>-->
<!--        </div>-->

        <div class="row" v-if="account.suspended_time">
          <span class="field">SUSPENDED TIME</span>
          <span class="value">{{ account.suspended_time }}</span>
        </div>
      </div>
    </div>

    <div class="contents--list">
      <div class="contents--list-subject">
        <span>Transfers</span>
        <RecordSelectBox :record="record" @changeRecord="changeRecord" />
      </div>

      <Table
        width="900px"
        data-type="transfers"
        :data="transfers"
        :account-address="account.address"
      />

      <Pagination
        v-if="!noResults"
        :minID="min_id"
        :currentID="current_id"
        :maxID="max_id"
        :lastID="last_id"
        :isDetail="false"
        :loading="loading"
        :firstPage="(this.current_id == this.max_id)"
        :lastPage="(this.last_id == this.min_id)"
        @flip="pageCall"
      />
    </div>
  </div>
</template>

<script>
import RecordSelectBox from "./shared/RecordSelectBox.vue";
import Table from "./shared/Table.vue";
import Pagination from "./shared/Pagination.vue";
import callAPI from "../../api/http";
import err from "../../js/error";
import { convertAttrFormat } from "../../js/format";
import { RecordOptions } from "../../js/fields";

export default {
  props: {
    bookmark: {
      type: Number,
      default: undefined,
    },
    pagesize: {
      type: Number,
      default: RecordOptions[0],
    },
    direction: {
      type: String,
      default: "first",
    },
    id: {
      type: Number,
      default: 0,
    },
  },

  components: {
    RecordSelectBox,
    Table,
    Pagination,
  },

  computed: {
    noResults() {
      return (this.totalTransfers == 0)
    },
  },

  async beforeRouteUpdate(to, from, next) {
    this.id = to.params.id;
    this.bookmark = to.query.bookmark || undefined;
    this.pagesize = to.query.pagesize || RecordOptions[0];
    this.direction = to.query.direction || "first";

    this.record = this.pagesize;

    await this.getAccount();
    next();
  },

  async created() {
    this.record = this.pagesize;

    await this.getAccount();
  },

  data() {
    return {
      copyButtonPressed: false,
      account: {},
      transfers: [],
      pagesize: RecordOptions[0],
      loading: false,
      totalTransfers: 0,
      min_id: 0,
      max_id: 0,
      last_id: 0,
      current_id: 0,
    };
  },

  methods: {
    async getAccount() {
      const { data: account, errCode } = await callAPI("getAccount", this.id);
      if (errCode) {
        err(errCode, this.id, this.$router);
        return;
      }

      this.account = account;
      this.address = account.address;

      await this.getTransfersOfAccount();
    },

    async getTransfersOfAccount() {
      this.loading = true;
      let param = {
        bookmark: this.bookmark,
        pagesize: this.pagesize,
        direction: this.direction,
        address: this.address,
      };
      const { data, errCode } = await callAPI("getTransfersOfAccount", param);
      this.setTransfers(data, errCode);
    },

    async pageCall(direction) {
      switch (direction) {
        case "next":
          this.bookmark = this.transfers[this.transfers.length - 1].id;
          this.direction = direction;
          if (this.bookmark == this.minID) {
            return;
          }
          await this.getTransfersOfAccount();
          break;
        case "prev":
          this.bookmark = this.transfers[0].id;
          this.direction = direction;
          if (this.bookmark == this.maxID) {
            return;
          }
          await this.getTransfersOfAccount();
          break;
        default:
          this.bookmark = undefined;
          this.direction = direction;
          await this.getTransfersOfAccount();
      }
    },

    async changeRecord(pagesize) {
      this.record = pagesize; // not re-routing, must set new record
      this.pagesize = pagesize;
      // this.direction = "first"; // reset to fist page
      await this.getTransfersOfAccount();
    },

    setTransfers(data, errCode) {
      if (errCode) {
        console.log(errCode);
        this.totalTransfers = 0;
        this.loading = false;
        return;
      }

      const { transfers, min_id, current_id, max_id } = data;

      if (transfers) {
        this.transfers = convertAttrFormat("TransfersList", transfers);
        this.min_id = min_id;
        this.current_id = current_id;
        this.max_id = max_id;
        this.last_id = transfers[transfers.length-1].id;
        this.totalTransfers = transfers.length;
      } else {
        this.totalTransfers = 0;
      }
      this.loading = false;
    },

    pressCopyButton() {
      this.copyButtonPressed = true;
    },
  },
};
</script>

<style lang="scss">
@import "../../scss/common";

.contents__account-detail-table {
  @include detailTableFieldWidth(150px);
}

%accountField {
  .holders {
    height: auto !important;

    .field {
      padding-top: 5px;
      align-items: flex-start;
    }

    .value {
      padding-top: 5px;
      flex-direction: column;
      align-items: flex-start;
    }

    a {
      height: 25px;
    }
  }

  .pb {
    .link {
      margin-left: 15px;
    }
  }
}

.contents {
  &__account-detail-table--include-pb {
    @include detailTableFieldWidth(177px);
    @extend %accountField;
  }

  &__account-detail-table {
    @include detailTableFieldWidth(150px);
    @extend %accountField;
  }
}
// .fade-enter,
// .fade-leave-to {
//   opacity: 0;
// }

// .fade-enter-active,
// .fade-leave-active {
//   transition: opacity 0.5s ease-out;
// }
</style>



// WEBPACK FOOTER //
// src/components/contents/Account.vue